module.exports = __webpack_public_path__ + "img/email.c8f5a832.svg";